// Company info for Snigdha & Associates, Chartered Accountants

export const companyInfo = {
  name: "Snigdha & Associates",
  fullName: "Snigdha & Associates, Chartered Accountants",
  tagline: "Your Trusted Partner in Business Compliance",
  description: "Premier Chartered Accountancy firm led by CA Snigdha Nigam & CA Sumit Nigam with 10+ years of experience in Startup Advisory, FEMA, RBI, Bank Audit, Taxation, Labor Laws, and Companies Act 2013.",
  email: "hi@snigdha360.com",
  phone: "+91 7570041003",
  whatsapp: "+91 7570041003",
  logo: "/logo.png",
  addresses: [
    {
      city: "Gwalior",
      address: "103, First Floor, Vindhyachal Complex, Opp Krishna Business Tower, City Center, Gwalior, MP 474002"
    },
    {
      city: "Indore",
      address: "5th Floor, BPK Titanium, 392/3 and 391/17, Vijay Nagar, Indore, MP 452010"
    }
  ],
  partners: [
    { name: "CA Snigdha Nigam", role: "Leading Partner" },
    { name: "CA Sumit Nigam", role: "Leading Partner" }
  ],
  experience: "10+ Years"
};

export const heroContent = {
  title: "Expert Chartered Accountancy Services",
  subtitle: "Your One Window Solution",
  description: "From company incorporation to annual compliance, taxation to payroll - we handle it all. Unlike automated filing platforms, we provide expert hand-holding through the intricate corridors of the MCA, RBI, and Income Tax Department.",
  cta: "Get Started",
  loginCta: "Client Login"
};

export const aboutContent = {
  title: "About Snigdha & Associates",
  subtitle: "Who We Are",
  description: "We are a premier Chartered Accountancy firm led by CA Snigdha Nigam and CA Sumit Nigam. With over a decade of hands-on experience, we specialize in navigating complex regulatory landscapes for startups and established firms alike.",
  usp: {
    title: "Our Core Value Proposition",
    subtitle: "The 'One Window' Solution",
    description: "Founders often waste valuable time coordinating between different agencies: a Company Secretary for incorporation, a CA for audits, and a separate HR consultant for payroll. We eliminate this fragmentation."
  },
  highlights: [
    "Expert-Led: Talk to qualified professionals, not support bots",
    "End-to-End: From incorporation to annual compliance",
    "10+ Years Experience in regulatory compliance",
    "Specialization in Startup Advisory & FEMA"
  ]
};

export const services = [
  {
    id: 1,
    title: "Corporate Compliance (CS)",
    description: "From incorporation to mandatory ROC filings - complete company secretarial services.",
    icon: "Building2",
    items: [
      "Private Limited / LLP / OPC Incorporation",
      "Annual ROC Filings (AOC-4, MGT-7)",
      "Director Changes (DIR-12)",
      "Registered Office Changes",
      "Capital Structure Changes"
    ]
  },
  {
    id: 2,
    title: "Taxation & Finance (CA)",
    description: "Statutory Audits, GST filing, TDS compliance, and professional bookkeeping services.",
    icon: "Calculator",
    items: [
      "Statutory Audits",
      "Income Tax Filing & Planning",
      "GST Registration & Returns",
      "TDS Compliance",
      "Bookkeeping & Accounting"
    ]
  },
  {
    id: 3,
    title: "Payroll & Labor Law",
    description: "Efficient CTC structuring with complete PF, ESIC, PT, and LWF compliance.",
    icon: "Users",
    items: [
      "CTC Structuring",
      "PF & ESIC Compliance",
      "Professional Tax (PT)",
      "Labor Welfare Fund (LWF)",
      "Employment Agreements"
    ]
  },
  {
    id: 4,
    title: "Startup Consulting & Grants",
    description: "End-to-end support for Startup India recognition, MSME registration, and state benefits.",
    icon: "Rocket",
    items: [
      "DPIIT Startup India Recognition",
      "MSME/Udyam Registration",
      "State Startup Policy Benefits",
      "Seed Fund Applications",
      "Incubator Connections"
    ]
  },
  {
    id: 5,
    title: "Intellectual Property (IP)",
    description: "Trademark search, filing, and brand protection strategies for your business.",
    icon: "Shield",
    items: [
      "Trademark Search & Filing",
      "Brand Protection Strategy",
      "Copyright Registration",
      "IP Portfolio Management"
    ]
  },
  {
    id: 6,
    title: "FEMA & RBI Compliance",
    description: "Specialized handling of foreign investments and cross-border transactions.",
    icon: "Globe",
    items: [
      "ODI Compliance",
      "FDI Compliance",
      "FC-GPR Filings",
      "External Commercial Borrowings",
      "LRS Compliance"
    ]
  }
];

export const whyChooseUs = [
  {
    title: "Expert-Led Service",
    description: "You don't talk to a support bot; you talk to qualified professionals who understand the intersection of Law, Tax, and HR.",
    icon: "UserCheck"
  },
  {
    title: "One Window Solution",
    description: "No more coordinating between CS, CA, and HR consultants. We handle everything under one roof.",
    icon: "Layers"
  },
  {
    title: "10+ Years Experience",
    description: "Decade of hands-on experience navigating complex regulatory landscapes for startups and established firms.",
    icon: "Award"
  },
  {
    title: "Digital-First Approach",
    description: "Completely digital process - no need to visit any government office. We handle everything remotely.",
    icon: "Monitor"
  }
];

export const entityComparison = {
  title: "Choosing the Right Entity",
  subtitle: "LLP vs Private Limited vs OPC",
  entities: [
    {
      type: "Private Limited",
      bestFor: "Startups seeking VC/Angel funding",
      pros: ["Can issue equity shares", "Investor preferred", "Easy to scale"],
      cons: ["Higher compliance", "Mandatory audit", "Quarterly board meetings"]
    },
    {
      type: "LLP",
      bestFor: "Service agencies & consulting firms",
      pros: ["Lower compliance", "Tax-efficient profit withdrawal", "No mandatory audit (below limits)"],
      cons: ["Cannot issue shares", "Limited funding options"]
    },
    {
      type: "OPC",
      bestFor: "Solo founders seeking limited liability",
      pros: ["Single person company", "Limited liability protection", "Easy to convert to Pvt Ltd"],
      cons: ["Cannot have foreign investment", "Limited to one member"]
    }
  ]
};

export const faqs = [
  {
    id: "faq-1",
    category: "Incorporation",
    question: "What documents do I need to incorporate a company?",
    answer: "You need: PAN Card, Aadhaar Card, Passport Size Photo, Phone & Email for all Directors/Shareholders. For registered office: Electricity Bill + Rent Agreement (if rented) or NOC from family member if using their property."
  },
  {
    id: "faq-2",
    category: "Incorporation",
    question: "How long does company incorporation take?",
    answer: "The total estimated time is roughly 15-20 days. Name approval takes 7-10 days, documentation runs parallel, final filing takes 3-5 days, and government approval takes about 7 days."
  },
  {
    id: "faq-3",
    category: "Incorporation",
    question: "Is there a minimum capital requirement to start?",
    answer: "No. The mandatory minimum paid-up capital requirement has been removed under the Companies Act, 2013. You can incorporate with nominal capital, though we recommend at least ₹10,000 to cover initial banking charges."
  },
  {
    id: "faq-4",
    category: "Compliance",
    question: "What are the mandatory annual compliances for a Pvt Ltd Company?",
    answer: "Even with zero turnover: Form AOC-4 (Annual Financial Statements), Form MGT-7 (Annual Return), Statutory Audit by a CA, and 4 Board Meetings (one per quarter) with maintained minutes."
  },
  {
    id: "faq-5",
    category: "Compliance",
    question: "What is DIN? Why do you need to check if it is Active?",
    answer: "DIN (Director Identification Number) is a unique ID issued by MCA for Directors. While valid for lifetime, you must file KYC every 3 years. If missed, your DIN is deactivated and requires ₹5,000 penalty to reactivate."
  },
  {
    id: "faq-6",
    category: "Tax",
    question: "What is the Tax Rate for different entities?",
    answer: "Pvt Ltd: ~25.17% (Section 115BAA) or ~17.16% for new manufacturing (Section 115BAB). LLP: Flat 30% + Cess/Surcharge. Note: While Pvt Ltd rates are lower, dividend withdrawal attracts additional tax. LLPs allow tax-free profit withdrawal."
  },
  {
    id: "faq-7",
    category: "Registration",
    question: "Can I get MSME / Udyam Registration?",
    answer: "Yes! Udyam Registration is available for both Manufacturing and Service enterprises. It's a lifetime registration with benefits like collateral-free loans, delayed payment protection, and subsidies on trademark filing."
  },
  {
    id: "faq-8",
    category: "Documents",
    question: "Why was my uploaded document rejected?",
    answer: "Government portals are strict about quality. Common rejection reasons: Background noise (photos on messy surfaces), bad lighting/blur, cropped edges. Documents must be scanned with a clean white background using a scanner or quality app like Adobe Scan."
  }
];

export const contactFormFields = [
  { name: "fullName", label: "Full Name", type: "text", required: true },
  { name: "email", label: "Email Address", type: "email", required: true },
  { name: "phone", label: "Phone Number", type: "tel", required: true },
  { name: "subject", label: "I need help with", type: "select", required: true, options: [
    "Company Incorporation",
    "Annual Compliance",
    "GST Registration & Filing",
    "Income Tax Filing",
    "Payroll & Labor Law",
    "Trademark Registration",
    "FEMA/RBI Compliance",
    "General Inquiry"
  ]},
  { name: "message", label: "Tell us more", type: "textarea", required: true }
];

export const processSteps = [
  {
    step: 1,
    title: "Consultation",
    description: "Brief discussion to finalize the right structure (LLP vs Pvt Ltd vs OPC)"
  },
  {
    step: 2,
    title: "Documentation",
    description: "You provide PAN/Aadhaar/Photo of Directors via our secure portal"
  },
  {
    step: 3,
    title: "Execution",
    description: "We handle DSC, DIN, Name Approval, and Incorporation"
  },
  {
    step: 4,
    title: "Delivery",
    description: "Receive your COI, PAN, TAN within 7-10 working days"
  }
];
